{
  "next": "Seuraava",
  "previous": "Edellinen"
}
